import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';
import type { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import type { Slug } from '@bridebook/toolbox/src/types';

interface ViewedSupplierMediaData {
  viewedSupplierCategory?: Slug;
  viewedSupplierId?: ISupplier['id'];
  viewedSupplierName?: ISupplier['name'];
  mediaType: 'photo' | 'video';
  mediaCarouselTotalItems: number;
  mediaCarouselCurrentItemNumber: number;
  ctaPhoto: boolean;
  supplierTier?: number;
}

export const viewedSupplierMedia: (payload: ViewedSupplierMediaData) => ThunkAction<void> =
  (payload: ViewedSupplierMediaData): ThunkAction<void> =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ViewedSupplierMedia,
      ...payload,
    });

//Viewed supplier profile on logged out page
export const viewedSupplierProfileOnLoggedOutPage: (payload: {
  supplierCountryCode: CountryCodes;
  viewedLocation?: string;
}) => ThunkAction<void> =
  (payload: { supplierCountryCode: CountryCodes; viewedLocation?: string }): ThunkAction<void> =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ViewedSupplierProfileOnLoggedOutPage,
      ...payload,
    });
